<template>
  <Card size="large">
    <View direction="column" gap="md">
      <Text variant="h3">{{ title }}</Text>
      <slot name="badges"></slot>
      <div class="info-items">
        <View gap="sm" direction="column" v-for="infoItem in infoItems" :key="infoItem.label">
          <Text variant="label-medium" color="tertiary">{{ infoItem.label }}</Text>
          <Text variant="body-medium">{{ infoItem.value }}</Text>
        </View>
      </div>
      <slot name="highlights"></slot>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { Card, Text, View } from '@tallo/design-system';

defineProps<{ title: string; infoItems: { label: string; value: string | number | undefined }[] }>();
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.info-items {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--t-spacing-md);

  @include screen-min-sm {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
